import { render, staticRenderFns } from "./DomainsSwitcher.vue?vue&type=template&id=cb236e24&scoped=true"
import script from "./DomainsSwitcher.vue?vue&type=script&lang=js"
export * from "./DomainsSwitcher.vue?vue&type=script&lang=js"
import style0 from "./DomainsSwitcher.vue?vue&type=style&index=0&id=cb236e24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb236e24",
  null
  
)

export default component.exports